import { useQuery } from '@tanstack/react-query';
import type {
  GetResearchConfigurationsLiteParams,
  ResearchConfigurationsLiteResponse,
} from '@types';
import { getUserConfigurationsLite } from '@services/configurationManager';
import { researchConfigurationsLiteQueryKey } from './keys';

export { researchConfigurationsLiteQueryKey } from './keys';

export const useResearchConfigurationsLiteQuery = (
  userId?: string,
  params?: GetResearchConfigurationsLiteParams
) => {
  return useQuery<ResearchConfigurationsLiteResponse>({
    queryKey: researchConfigurationsLiteQueryKey(userId, params),
    queryFn: () => getUserConfigurationsLite(userId!, params),
    enabled: Boolean(userId),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    placeholderData: previous => previous,
  });
};
